/**
 * API Timeout Configuration
 *
 * Defines timeout values for different types of API requests.
 * Based on sub-plan BR-ERR008: Timeout Gestion
 */

export const API_TIMEOUTS = {
  /** Default timeout for standard API calls (30 seconds) */
  default: 30000,

  /** Timeout for document uploads (60 seconds for 10MB files) */
  upload: 60000,

  /** Timeout for Docmana AI document analysis (90 seconds for complex analysis) */
  docmanaAnalysis: 90000,

  /** Timeout for quick validation calls (15 seconds) */
  validation: 15000,

  /** Timeout for health checks (5 seconds) */
  health: 5000,
} as const;

export type TimeoutType = keyof typeof API_TIMEOUTS;

/**
 * Get timeout value for a specific request type
 */
export function getTimeout(type: TimeoutType = 'default'): number {
  return API_TIMEOUTS[type];
}

export default API_TIMEOUTS;
